<template>
  <div class="exam">
    <div class="nuv">
      <span>群培训管理&nbsp;&gt;</span>
      <span>{{ groupName }}</span>
    </div>
    <a href="javascript:;" class="top-button"><el-button type="primary">群考核名单</el-button></a>
    <el-tooltip placement="right" effect="light">
      <div slot="content" class="tip-con">
        <p>1、群考核名单是指没有通过岗前培训的名单</p>
      </div>
      <a class="tip-box">？</a>
    </el-tooltip>
    <tjkautocomplete @callBack="updateTjkId"></tjkautocomplete>
    <el-button type="danger" style="margin-left: 10px;" @click="getList('tjk')">查询淘金客</el-button>
    <el-input type="textarea" v-model="tjkNumbers" placeholder="输入淘金号，用英文逗号隔开，例如940732001,949329488" :autosize="{ minRows: 2, maxRows: 3}" style="width: 400px;margin-left: 10px;margin-bottom: 5px;"></el-input>
    <el-button type="danger" style="margin-left: 10px;" @click="getList('tjkNumbers')">批量查询</el-button>
    <ul class="tab">
      <li v-for="(t, key) in examiningList" :class="{active: t.isCurrent}">
        <template v-if="t.isCurrent">
          <a :href="'/tjkStudy/voiceExam?id='+t.examineRecordId+'&groupId='+groupId+'&groupName='+groupName" target="_blank">{{ t.codeName }}&nbsp;&nbsp;剩余考核人：{{ t.waitNum }}</a>
        </template>
        <template v-else>
          {{ t.codeName }}&nbsp;&nbsp;剩余考核人：{{ t.waitNum }}
        </template>
      </li>
    </ul>
    <p v-if="!success" class="tj-shift-notice">{{ message }}</p>
    <template v-else>
      <p class="tj-shift-notice" v-if="!list.length" style="padding-top: 45px;">暂无记录！</p>
      <template v-else>
        <el-table ref="multipleTable" border :data="list" :height="type == 'Voice' ? tableHeight : onlineTableHeight" tooltip-effect="dark" style="width: 100%;" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center"></el-table-column>
          <el-table-column prop="realName" label="考核人员" align="center"></el-table-column>
          <el-table-column prop="tjkNumber" label="淘金号" align="center"></el-table-column>
          <el-table-column label="是否通过" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.passState" placeholder="请选择">
                <el-option key="Passed" label="通过" value="Passed"></el-option>
                <el-option key="Failed" label="未通过" value="Failed"></el-option>
                <el-option key="Abandoned" label="标记不参培" value="Abandoned"></el-option>
                <el-option key="Retrial" label="建议复训" value="Retrial"></el-option>
                <el-option key="AbandonInTrain" label="培训老师同意放弃" value="AbandonInTrain"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="score" label="综合得分" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.score" placeholder="只能填写数字" clearable></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center">
            <template slot-scope="scope">
              <el-input type="textarea" autosize placeholder="不能超过200字" v-model="scope.row.remark" clearable></el-input>
            </template>
          </el-table-column>
        </el-table>
        <div class="tj-margin-top-xl">
          <el-button type="success" @click="toggleSelection('Passed')">标记通过</el-button>
          <el-button type="info" @click="toggleSelection('Failed')">标记不通过</el-button>
          <template v-if="type == 'Voice'"><el-button type="warning" @click="checkGroup">群考核</el-button></template>
          <template v-if="type == 'Online'"><el-button type="primary" @click="saveOnline">保存打分</el-button></template>
          <template v-if="type == 'Voice'"><el-button type="primary" @click="saveVoice">保存打分</el-button></template>
          <el-button type="danger" @click="releaseGroup">发布成绩</el-button>
        </div>
      </template>
    </template>
    <!-- 群考核弹出层 -->
    <Modal ref="check">
      <div class="tj-table tj-fill tj-padding-right-xl">
        <dl>
          <dt class="tj-text-right"><font color="red">*</font> 外呼电话：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model="check.callOutPhone" clearable></el-input>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 平均外呼时长（分钟）：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model="check.avgDuration" clearable></el-input>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 考核代号：</dt>
          <dd>
            <el-input placeholder="请输入内容" v-model="check.codeName" clearable></el-input>
          </dd>
        </dl>
      </div>
    </Modal>
    <!-- 发布成绩弹出层 -->
    <Modal ref="release">
      <div class="tj-table tj-fill tj-padding-right-xl" style="border-bottom: 1px solid #f2f2f2;">
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 考核通过流转群：</dt>
          <dd>
            <el-select v-model="release.shopGroupId" placeholder="请选择">
              <el-option v-for="(g, key) in shopGroupList" :key="g.groupId" :label="g.name" :value="g.groupId"></el-option>
            </el-select>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 考核未通过学员：</dt>
          <dd>
            <el-select v-model="release.failedState" placeholder="请选择">
              <el-option key="Kicked" label="踢出本群" value="Kicked"></el-option>
            </el-select>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 放弃和培训中放弃的学员：</dt>
          <dd>
            <el-select v-model="release.abandonState" placeholder="请选择">
              <el-option key="Kicked" label="踢出本群" value="Kicked"></el-option>
            </el-select>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 通过发送的消息：</dt>
          <dd>
            <el-input type="textarea" :rows="3" placeholder="恭喜你通过了本次考核。" v-model="release.passedMsg"></el-input>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 留在本群发送的消息：</dt>
          <dd>
            <el-input type="textarea" :rows="3" placeholder="考核成绩已发布。" v-model="release.stayMsg"></el-input>
          </dd>
        </dl>
        <dl>
          <dt class="tj-text-right" style="width: 200px;"><font color="red">*</font> 踢出本群发送的消息：</dt>
          <dd>
            <el-input type="textarea" :rows="3" placeholder="考核成绩已发布，很遗憾你没有通过本次考核。" v-model="release.kickMsg"></el-input>
          </dd>
        </dl>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      'success': true,
      'message': '',
      'groupId': this.$route.query.groupId,
      'groupName': this.$route.query.groupName, //考核群名称
      'tjkId': '', //搜索的淘金客id
      tjkNumbers: '', //批量淘金号
      'type': '',
      'multipleSelection': [],
      'check': {
        'callOutPhone': '',
        'avgDuration': '',
        'codeName': ''
      },
      'release': {
        'shopGroupId': '',
        'failedState': 'Kicked',
        'abandonState': 'Kicked',
        'passedMsg': '恭喜你通过了本次考核。',
        'stayMsg': '考核成绩已发布。',
        'kickMsg': '考核成绩已发布，很遗憾你没有通过本次考核。（已释放，可以去领取新的任务!)'
      },
      'list': [],
      'examiningList': [], //正在考核列表
      'basicGroupList': [], //基础培训群列表
      'shopGroupList': [], //流转群列表
      'shopId': '', //店铺id
      'tableHeight': window.innerHeight - 270,
      'onlineTableHeight': window.innerHeight - 220
    }
  },
  mounted: function() {
    this.getBasicGroup()
    this.getList()
  },
  methods: {
    myAlert(msg) {
      this.$alert(msg, '系统提示', {
        confirmButtonText: '确定',
        callback: action => {
          
        }
      })
    },
    //查询基础培训群
    getBasicGroup() {
      this.$http.post(API_ROOT.teamTalk + '/retrial/group/queryAll').then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.basicGroupList = result.data
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //查询流转群
    getShopGroup() {
      this.$http.post(API_ROOT.teamTalk + '/shopGroup/queryAllGroupsByShopId', {'shopId': this.shopId}, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
        var result = response.data
        if(result.success) {
          this.shopGroupList = result.data
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },

    getList(opetype) {
      //opetype:标记当前查询是按 单查 还是 批量查【tjk|tjkNumbers】
      var tjkId = opetype == 'tjk' ? this.tjkId : null;
      var tjkNumbers = opetype == 'tjkNumbers' ? this.tjkNumbers : null;
      var data = {
        'groupId': this.groupId,
        'tjkId': tjkId,
        'tjkNumbers': tjkNumbers
      }
      this.$http.post(API_ROOT.college + '/examine/query', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
        var result = response.data
        if(result.success) {
          this.success = result.success
          this.message = result.msg
          this.type = result.data.type
          this.shopId = result.data.shopId
          this.list = result.data.tjkList
          this.examiningList = result.data.examiningList
        }else {
          this.myAlert(result.msg)
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //语音打分保存
    saveVoice() {
      var self = this,
          ids = [],
          isOkVoice = true, //表单是否校验通过
          reg = /^[1-9]\d*|0$/
      self.list.map((item)=> {
        if((!!item.score && !reg.test(item.score))) {
          self.myAlert('分数只能是非负整数')
          isOkVoice = false
          return false
        }
        if(!!item.remark && item.remark.length > 200) {
          self.myAlert('备注不能超过200字')
          isOkVoice = false
          return false
        }
      })
      self.list.map((item)=> {
        if(!!item.passState) {
          ids.push({
            'examineId': !!item.examineId ? item.examineId : '',
            'groupId': self.groupId,
            'taskId': item.taskId,
            'tjkId': item.tjkId,
            'passState': item.passState,
            'remark': !!item.remark ? item.remark : '',
            'score': !!item.score ? item.score : 0
          })
        }
      })

      if(isOkVoice) {
        self.$http.post(API_ROOT.college + '/voice/examine/json/batchScore', ids).then(response => {
          var result = response.data
          if(result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            })
            self.type = result.data.type
            self.list = result.data.tjkList
          } else {
            self.myAlert(result.msg)
            self.getList()
          }
        }, response => {
          self.myAlert('网络繁忙，请稍后重试！')
        })
      }
    },
    //在线打分保存
    saveOnline() {
      var self = this,
          ids = [],
          isOk = true, //表单是否校验通过
          reg = /^[1-9]\d*|0$/
      self.list.map((item)=> {
        if((!!item.score && !reg.test(item.score))) {
          self.myAlert('分数只能是非负整数')
          isOk = false
          return false
        }
        if(!!item.remark && item.remark.length > 200) {
          self.myAlert('备注不能超过200字')
          isOk = false
          return false
        }
      })
      self.list.map((item)=> {
        if(!!item.passState) {
          ids.push({
            'examineId': !!item.examineId ? item.examineId : '',
            'groupId': self.groupId,
            'tjkId': item.tjkId,
            'taskId': item.taskId,
            'passState': item.passState,
            'remark': !!item.remark ? item.remark : '',
            'score': !!item.score ? item.score : 0
          })
        }
      })

      if(isOk) {
        self.$http.post(API_ROOT.college + '/online/examine/json/score', ids).then(response => {
          var result = response.data
          if(result.success) {
            self.$message({
              message: '操作成功',
              type: 'success',
              center: true,
              duration: 1000
            })
            self.type = result.data.type
            self.list = result.data.tjkList
          } else {
            self.myAlert(result.msg)
            self.getList()
          }
        }, response => {
          self.myAlert('网络繁忙，请稍后重试！')
        })
      }
    },
    //群考核
    checkGroup() {
      var self = this
      self.check.callOutPhone = ''
      self.check.avgDuration = ''
      self.check.codeName = ''

      //发起考核前查询是否存在未结束的考核
      this.$http.post(API_ROOT.college + '/voice/examine/existStartedExamine', {'groupId': self.groupId, 'recordType': 'PreExamine'}, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
        var result = response.data
        if(result.success) {
          if(result.data) {
            self.myAlert('存在未结束的考核，考核结束后才能再次发起群考核！')
          }else {
            //不存在即发起考核
            var ids = []
            self.multipleSelection.map((item)=> {
              ids.push(item.tjkId)
            })
            if(ids.length == 0) {
              self.myAlert('请先选择淘金客')
              return false
            }
            this.$refs.check.open({
              title: '群考核',
              width: 800,
              callBack: function (arg) {
                if (arg.type === 'cancel') {
                  arg.close()
                  return
                }
                if(self.check.callOutPhone == '') {
                  self.myAlert('外呼电话不能为空')
                  return false
                }
                if(self.check.avgDuration == '') {
                  self.myAlert('平均外呼时长不能为空')
                  return false
                }
                if(self.check.codeName == '') {
                  self.myAlert('考核代号不能为空')
                  return false
                }
                var reg = /^[0-9]*[1-9][0-9]*$/
                if(!reg.test(self.check.callOutPhone) || !reg.test(self.check.avgDuration)) {
                  self.myAlert('只能填写正整数')
                  return false
                }
                if (arg.pending()) return
                arg.pending(true)

                var data = {
                  'groupId': self.groupId,
                  'callOutPhone': self.check.callOutPhone,
                  'avgDuration': self.check.avgDuration,
                  'codeName': self.check.codeName,
                  'tjkIds': ids
                }
                self.$http.post(API_ROOT.college + '/voice/examine/start', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
                  arg.pending(false)
                  var result = response.data
                  if(result.success) {
                    self.$message({
                      message: '已添加',
                      type: 'success',
                      center: true,
                      duration: 1000
                    })
                    arg.close()
                    window.location.href = '/tjkStudy/voiceExam?id='+result.data+'&groupId='+self.groupId+'&groupName='+self.groupName
                  } else {
                    self.myAlert(result.msg)
                  }
                }, response => {
                  self.myAlert('网络繁忙，请稍后重试！')
                })
              }
            })
          }
        }else {
          self.myAlert(result.msg)
        }
      }, response => {
        self.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //发布成绩
    releaseGroup() {
      var self = this
      self.getShopGroup()
      self.release.failedState = 'Kicked'
      self.release.abandonState = 'Kicked'
      self.release.shopGroupId = ''
      self.release.passedMsg = '恭喜你通过了本次考核。'
      self.release.stayMsg = '考核成绩已发布。'
      self.release.kickMsg = '考核成绩已发布，很遗憾你没有通过本次考核。（已释放，可以去领取新的任务!)'
      //筛选状态有值的淘金客
      var ids = []
      if(self.multipleSelection.length > 0) {
        self.multipleSelection.map((item)=> {
          ids.push(item.examineId)
        })
      }
      this.$refs.release.open({
        title: '学员处理',
        width: 800,
        callBack: function (arg) {
          if (arg.type === 'cancel') {
            arg.close()
            return
          }
          if(self.release.waitJobMsg == '' || self.release.stayMsg == '' || self.release.kickMsg == '' || self.release.retrialMsg == '') {
            self.myAlert('发送消息不能为空')
            return false
          }
          if (arg.pending()) return
          arg.pending(true)

          var data = {
            'groupId': self.groupId,
            'passed.state': 'Enroll',
            'failed.state': self.release.failedState,
            'abandon.state': self.release.abandonState,
            'shopGroupId': self.release.shopGroupId,
            'stayMsg': self.release.stayMsg,
            'kickMsg': self.release.kickMsg,
            'passedMsg': self.release.passedMsg,
            'examineIds': ids
          }
          self.$http.post(API_ROOT.college + '/voice/examine/publish', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
            arg.pending(false)
            var result = response.data
            if(result.success) {
              self.$message({
                message: '已发布',
                type: 'success',
                center: true,
                duration: 1000
              })
              arg.close()
              self.type = result.data.type
              self.list = result.data.tjkList
            } else {
              self.myAlert(result.msg)
              self.getList()
            }
          }, response => {
            self.myAlert('网络繁忙，请稍后重试！')
          })
        }
      })
    },
    //全选/全不选 标记是否通过
    toggleSelection(passState) {
      var ids = []
      this.multipleSelection.map((item)=> {
        ids.push(item.examineId)
      })
      if(ids.length == 0) {
        this.myAlert('请先选择淘金客')
        return false
      }
      var data = {
        'groupId': this.groupId,
        'examineIds': ids,
        'passState': passState
      }
      this.$http.post(API_ROOT.college + '/examine/mark', data, {headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}}).then(response => {
        var result = response.data
        if(result.success) {
          this.$message({
            message: '操作成功',
            type: 'success',
            center: true,
            duration: 1000
          })
          this.type = result.data.type
          this.list = result.data.tjkList
        }else {
          this.myAlert(result.msg)
          this.getList()
        }
      }, response => {
        this.myAlert('网络繁忙，请稍后重试！')
      })
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    //淘金客自动搜索
    updateTjkId(val) {
      this.tjkId = val
    }
  }
}
</script>
<style type="less" scoped>
.nuv {
  font-size: 16px;
}
.top-button {
  margin: 10px 15px 20px 0;
  display: inline-block;
}
.tab > li {
  float: left;
  padding: 10px;
  margin-bottom: 20px;
  background-color: #ffffff;
  border: 1px solid #dfdfdf;
  margin-right: 10px;
  border-radius: 4px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
}
.tab > li.active {
  background-color: #ecf5ff;
  border: 1px solid #b3d8ff;
  color: #ffffff;
  cursor: pointer;
}
.tab > li.active:hover {
  background-color: #409EFF;
}
.tab > li.active:hover > a {
  color: #ffffff;
}
.tip-box {
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 1px solid #80a9f5;
  text-align: center;
  margin-right: 20px;
}
.tip-con {
  font-size: 14px;
  line-height: 24px;
}
/deep/ .el-table .el-table__cell {
    padding: 2px;
    font-size:12px;
}
/deep/ .el-table .el-table__cell input {
    height: 30px;
}
.el-button{
    padding: 10px 20px;
    font-size:12px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/college/groupTrain.vue